module.exports = __webpack_public_path__ + "img/column1.09853d76.png";